import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import DownloadIMQsPageStore, { DownloadIMQsPageStoreContext } from 'store/pages/quote/download-imqs/pageStore';
import { PageContent } from 'components/quote/download-imqs';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';

const DownloadIMQsPage: React.FC = observer(() => {
  const domainParams = useQuoteDomainParams();
  const pageStore = useMemo(
    () => new DownloadIMQsPageStore(domainParams),
    [domainParams.groupId, domainParams.periodId, domainParams.cartId],
  );

  return (
    <DownloadIMQsPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </DownloadIMQsPageStoreContext.Provider>
  );
});

export default DownloadIMQsPage;
